import React, { useContext, useMemo } from 'react';
import { CalendarContext } from '@features/Calendar/CalendarContext';
import { GenericEventIcon } from '@features/Calendar/constants';
import clsx from 'classnames';
function GenericEvent(params) {
    const { state: { detailed } } = useContext(CalendarContext);
    const typeIcon = useMemo(() => {
        var _a;
        return React.createElement("i", { className: (_a = GenericEventIcon[params.genericEvent.eventType]) !== null && _a !== void 0 ? _a : 'fa-light fa-square-question' });
    }, [params.genericEvent.eventType]);
    return (React.createElement("div", { className: clsx('cal__event --unassigned', { '--detailed': detailed }), style: { color: '#000' } },
        React.createElement("div", { className: "event__crux" },
            React.createElement("span", { className: "event__type" }, typeIcon),
            React.createElement("span", { className: "event__time" }, params.genericEvent.start.format('hh:mm A'))),
        React.createElement("div", { className: "event__title" }, params.genericEvent.title),
        React.createElement("div", { className: "event__indicate" },
            React.createElement("span", { className: "--unassigned", style: { display: 'flex', alignItems: 'center' } },
                React.createElement("i", { className: "fa-light fa-user-helmet-safety" }))),
        detailed && (React.createElement("div", { className: "event__details" }, params.genericEvent.technicians.map((technician) => technician.name).join(', ')))));
}
export default React.memo(GenericEvent);
